import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["actions", "carousel", "className", "id", "level"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, createContext, useState } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './FeatureHeader.styles';
import Carousel from './components/Carousel';
import IconButton from '../IconButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FeatureHeaderContext = createContext();
var FeatureHeader = forwardRef(function (_ref, ref) {
  var _cx, _carousel$activeIndex, _carousel$slides$acti, _carousel$slides$acti2;

  var actions = _ref.actions,
      carousel = _ref.carousel,
      customClassName = _ref.className,
      id = _ref.id,
      _ref$level = _ref.level,
      level = _ref$level === void 0 ? 'one' : _ref$level,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-featureheader"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var _useState = useState((_carousel$activeIndex = carousel === null || carousel === void 0 ? void 0 : carousel.activeIndex) !== null && _carousel$activeIndex !== void 0 ? _carousel$activeIndex : 0),
      _useState2 = _slicedToArray(_useState, 1),
      activeIndex = _useState2[0];

  var slideHasImage = (_carousel$slides$acti = carousel === null || carousel === void 0 ? void 0 : (_carousel$slides$acti2 = carousel.slides[activeIndex]) === null || _carousel$slides$acti2 === void 0 ? void 0 : _carousel$slides$acti2.image) !== null && _carousel$slides$acti !== void 0 ? _carousel$slides$acti : false;
  var hasCloseBtn = actions.close;

  var handleClose = function handleClose() {
    var _actions$close;

    (actions === null || actions === void 0 ? void 0 : (_actions$close = actions.close) === null || _actions$close === void 0 ? void 0 : _actions$close.onClick) && actions.close.onClick();
  };

  return _jsx(FeatureHeaderContext.Provider, {
    value: {
      level: level,
      slideHasImage: slideHasImage
    },
    children: _jsx(ThemeProvider, {
      theme: {
        level: level
      },
      children: _jsxs(Styled.FeatureHeader, _objectSpread(_objectSpread({
        ref: ref,
        className: className
      }, rest), {}, {
        children: [hasCloseBtn && _jsx(Styled.CloseButton, {
          children: _jsx(IconButton, {
            size: "small",
            variant: "tertiary",
            icon: "cross",
            onClick: handleClose
          })
        }), _jsx(Carousel, {
          data: carousel
        }), _jsx(Styled.Surface, {
          slideHasImage: slideHasImage
        })]
      }))
    })
  });
});
export default FeatureHeader;